import apolloClient from './../apolloClient.js'
import Vue from 'vue'
import checkDateInRange from './../helpers/checkDateInRange'

const state = {
  orders: [],
  order: {},
  loading: false,
  params: {
    dateFrom: '',
    dateTo: '',
    mode: ''
  },
  showModal: null,
  confirmTransition: null,
  editOrder: null,
  activeOrderId: null
}

const mutations = {
  SET_ORDERS (state, orders) {
    state.orders = []
    orders.forEach((order) => {
      state.orders.push(Object.assign({}, order))
    })
  },
  ADD_ORDER (state, order) {
    if (checkDateInRange(state.params.dateFrom, state.params.dateTo, order.date)) {
      state.orders.push(Object.assign({}, order))
    }
  },
  UPDATE_ORDER (state, order) {
    state.order = Object.assign({}, order)
    let index = state.orders.findIndex(o => o.id === order.id)
    if (index !== -1) {
      Vue.set(
        state.orders,
        index,
        Object.assign({}, order)
      )
    }
  },
  DELETE_ORDER (state, id) {
    let index = state.orders.findIndex(o => o.id === id)
    if (index !== -1) {
      Vue.delete(
        state.orders,
        index
      )
    }
  },
  SET_CONFIRM_TRANSITION (state, value) {
    state.confirmTransition = value
  },
  // CANCEL_ORDER (state, id) {
  //   let index = state.orders.findIndex(o => o.id === id)
  //   if (index !== -1) {
  //     state.orders[index].status = {
  //       __typename: 'Status',
  //       class: 'btn-danger',
  //       code: 'canceled',
  //       id: 4,
  //       name: 'Отменен'
  //     }
  //   }
  // },
  COMMENT_HAS_BEEN_ADDED (state, comment) {
    let index = state.orders.findIndex(o => o.id === comment.orderId)
    if (index !== -1) {
      state.orders[index].commentsCount += 1
    }
  },
  COMMENT_HAS_BEEN_UNVIEWED (state, comment) {
    let index = state.orders.findIndex(o => o.id === comment.orderId)
    if (index !== -1) {
      state.orders[index].commentsCountUnviewed += 1
    }
  },
  COMMENTS_HAS_BEEN_VIEWED (state, orderId) {
    let index = state.orders.findIndex(o => o.id === orderId)
    if (index !== -1) {
      state.orders[index].commentsCountUnviewed = 0
    }
  },
  SET_LOADING (state, value) {
    state.loading = value
  },
  SET_PARAMS (state, params) {
    state.params = params
  },
  SET_SHOW_ORDER_MODAL (state, value) {
    state.showModal = value
  },
  SET_EDIT_ORDER (state, order) {
    state.editOrder = order
  },
  SET_ACTIVE_ORDER_ID (state, id) {
    state.activeOrderId = id
  },
  SET_ORDER (state, order) {
    state.order = Object.assign({}, order)
  },
  CLEAR_ORDER_DATA (state) {
    state.order = {}
  }
}

import getOrdersQuery from './../gql/queries/getOrders.graphql'
import getOrderByIdQuery from './../gql/queries/getOrderById.graphql'
import addOrderMutation from './../gql/mutations/AddOrder.graphql'
import updateOrderMutation from './../gql/mutations/UpdateOrder.graphql'
import cancelOrderMutation from './../gql/mutations/CancelOrder.graphql'
import problemOrderMutation from './../gql/mutations/ProblemOrder.graphql'
import closeOrderMutation from './../gql/mutations/CloseOrder.graphql'
import orderTransitionMutation from '../gql/mutations/OrderTransition.graphql'
import deleteOrderMutation from './../gql/mutations/DeleteOrder.graphql'
import router from './../router'
const actions = {
  /**
   * Получить список заказов
   * @param commit
   * @param params Параметры поиска заказов
   */
  getOrders: ({commit}, params) => {
    return new Promise((resolve, reject) => {
      commit('SET_LOADING', true)
      commit('SET_PARAMS', {})
      apolloClient.query({
        query: getOrdersQuery,
        variables: {
          id: params.id,
          dateFrom: params.dateFrom,
          dateTo: params.dateTo,
          cityId: params.cityId,
          companyId: params.companyId,
          techcenterId: params.techcenterId,
          userId: params.userId,
          status: params.status,
          clientPhone: params.clientPhone,
          canceled: params.canceled,
          problem: params.problem
        },
        fetchPolicy: 'network-only'
      }).then((result) => {
        commit('SET_ORDERS', result.data.orders)
        commit('SET_PARAMS', params)
        commit('SET_LOADING', false)
        resolve(result)
      }).catch((error) => {
        console.log(error)
        commit('SET_LOADING', false)
        reject(error)
      })
    })
  },
  /**
   * Добавить заказ
   * @param commit
   * @param order
   * @return {Promise}
   */
  addOrder: ({commit}, order) => {
    return new Promise((resolve, reject) => {
      apolloClient.mutate({
        mutation: addOrderMutation,
        variables: {
          orderDate: order.orderDate,
          orderTime: order.orderTime,
          techcenterId: order.techcenterId,
          description: order.description,
          clientName: order.clientName,
          clientPhone: order.clientPhone,
          isSmsAboutAdd: order.isSmsAboutAdd,
          isSmsRemindOnTheEve: order.isSmsRemindOnTheEve,
          sum: order.sum
        }
      }).then((result) => {
        commit('ADD_ORDER', result.data.addOrder)
        resolve(result)
      }).catch((error) => {
        console.log(error)
        reject(error)
      })
    })
  },
  /**
   * Обновить заказ
   * @param commit
   * @param order
   * @return {Promise}
   */
  updateOrder: ({commit}, order) => {
    return new Promise((resolve, reject) => {
      apolloClient.mutate({
        mutation: updateOrderMutation,
        variables: {
          id: order.id,
          orderDate: order.orderDate,
          orderTime: order.orderTime,
          techcenterId: order.techcenterId,
          description: order.description,
          clientName: order.clientName,
          clientPhone: order.clientPhone,
          isSmsAboutAdd: order.isSmsAboutAdd,
          isSmsRemindOnTheEve: order.isSmsRemindOnTheEve,
          sum: order.sum
        }
      }).then((result) => {
        // Если номер заказа не совпадает, значит это была перезапись в другой техцентр и заказ был отменен
        // Вместо обновления данных в store ловим обновление заказа через web socket
        if (order.id !== result.data.updateOrder.id) {
          // order.status = {
          //   __typename: 'Status',
          //   class: 'btn-danger',
          //   code: 'canceled',
          //   id: 4,
          //   name: 'Отменен'
          // }
          // commit('CANCEL_ORDER', order.id)
          commit('ADD_ORDER', result.data.updateOrder)
        } else {
          commit('UPDATE_ORDER', result.data.updateOrder)
        }
        resolve(result)
      }).catch((error) => {
        console.log(error)
        reject(error)
      })
    })
  },
  /**
   * Удаление заказа
   * @param commit
   * @param id
   * @return {Promise}
   */
  deleteOrder: ({commit}, id) => {
    return new Promise((resolve, reject) => {
      apolloClient.mutate({
        mutation: deleteOrderMutation,
        variables: {
          id: id
        }
      }).then((result) => {
        if (result.data) {
          commit('DELETE_ORDER', id)
          resolve(result)
        } else {
          console.log(result)
          reject(result)
        }
      }).catch((error) => {
        console.log(error)
        reject(error)
      })
    })
  },
  /**
   * Установка Состояния заказа
   * @param state
   * @param commit
   * @param dispatch
   * @param params
   * @return {Promise}
   */
  setOrderTransition: ({ state, commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      apolloClient.mutate({
        mutation: orderTransitionMutation,
        variables: {
          code: params.code,
          orderId: params.orderId,
          sum: params.sum,
          profit: params.profit,
          comment: params.comment
        }
      })
        .then((result) => {
          commit('UPDATE_ORDER', result.data.orderTransition)
          resolve(result)
        }).catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  /**
   * Закрыть заказ
   * @param state
   * @param commit
   * @param params
   * @return {Promise}
   */
  closeOrder: ({ state, commit }, params) => {
    return new Promise((resolve, reject) => {
      apolloClient.mutate({
        mutation: closeOrderMutation,
        variables: {
          orderId: params.orderId,
          sum: params.sum,
          profit: params.profit
        }
      })
        .then((result) => {
          commit('UPDATE_ORDER', result.data.closeOrder)
          resolve(result)
        }).catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  /**
   * Отменить заказ
   * @param state
   * @param commit
   * @param params
   * @return {Promise}
   */
  cancelOrder: ({ state, commit }, params) => {
    return new Promise((resolve, reject) => {
      apolloClient.mutate({
        mutation: cancelOrderMutation,
        // Parameters
        variables: {
          orderId: params.orderId,
          value: params.value,
          cause: params.cause
        }
      })
        .then((result) => {
          commit('UPDATE_ORDER', result.data.cancelOrder)
          resolve(result)
        }).catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  /**
   * Проблемный заказ
   * @param state
   * @param commit
   * @param params
   * @return {Promise}
   */
  problemOrder: ({state, commit}, params) => {
    return new Promise((resolve, reject) => {
      apolloClient.mutate({
        mutation: problemOrderMutation,
        // Parameters
        variables: {
          orderId: params.orderId,
          value: params.value,
          cause: params.cause
        }
      })
        .then((result) => {
          commit('UPDATE_ORDER', result.data.problemOrder)
          resolve(result)
        }).catch((error) => {
          console.log(error)
          reject(error)
        })
    })
  },
  /**
   * Добавление заказа в store по id, вызывается в случае евента о новом заказе
   * @param state
   * @param commit
   * @param orderId
   * @return {Promise}
   */
  addOrderStoreById: ({state, commit}, orderId) => {
    return new Promise((resolve, reject) => {
      apolloClient.query({
        query: getOrdersQuery,
        variables: {
          id: [orderId]
        },
        fetchPolicy: 'network-only'
      }).then((result) => {
        if (result.data.orders[0]) {
          commit('ADD_ORDER', result.data.orders[0])
          resolve(result.data.orders[0])
        } else {
          console.log(result)
          reject(result)
        }
      }).catch((error) => {
        console.log(error)
        reject(error)
      })
    })
  },
  /**
   * Обновление заказа в store по id, вызывается в случае евента о изменении заказа
   * @param state
   * @param commit
   * @param orderId
   * @return {Promise}
   */
  updateOrderStoreById: ({state, commit}, orderId) => {
    return new Promise((resolve, reject) => {
      apolloClient.query({
        query: getOrdersQuery,
        variables: {
          id: [orderId]
        },
        fetchPolicy: 'network-only'
      }).then((result) => {
        if (result.data.orders[0]) {
          commit('UPDATE_ORDER', result.data.orders[0])
          resolve(result.data.orders[0])
        } else {
          console.log(result)
          reject(result)
        }
      }).catch((error) => {
        console.log(error)
        reject(error)
      })
    })
  },
  setActiveOrderId ({commit}, id) {
    commit('SET_ACTIVE_ORDER_ID', id)
  },
  setEditOrder ({commit}, order) {
    commit('SET_EDIT_ORDER', order)
  },
  setConfirmTransition ({commit}, transition) {
    commit('SET_CONFIRM_TRANSITION', transition)
  },
  showOrderDetail ({commit, dispatch}, id) {
    const params = {
      id: [id],
      mode: 'search'
    }
    window.localStorage.setItem('displayMode', 'search')
    window.localStorage.setItem('displayModeParams', JSON.stringify(params))
    dispatch('setActiveOrderId', id)
    if (router.currentRoute.name !== 'Orders') {
      router.push({name: 'Orders'})
    } else {
      dispatch('getOrders', params)
    }
  },
  /**
   * Получение заказа детально
   * @param commit
   * @param id
   * @param imgWidth
   * @param imgHeight
   * @returns {Promise<any>}
   */
  getOrderById: ({commit}, {id}) => {
    return new Promise((resolve, reject) => {
      apolloClient.query({
        query: getOrderByIdQuery,
        variables: {
          id: [id]
        },
        fetchPolicy: 'network-only'
      }).then((result) => {
        if (result.data.orders[0]) {
          commit('SET_ORDER', result.data.orders[0])
        }
        resolve(result)
      }).catch((error) => {
        console.warn(error)
        reject()
      })
    })
  }
}

export default {
  state, mutations, actions
}



// WEBPACK FOOTER //
// ./src/store/orderStore.js